/**
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Injectable, inject, DestroyRef } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { Meta, Title } from '@angular/platform-browser'
import { TranslateService } from '@ngx-translate/core'
import { combineLatest, filter, map, take } from 'rxjs'
import { META_TITLE_FALLBACKS, pageTitleSeparator } from './meta-fields.constants'

@Injectable({
  providedIn: 'root',
})
export class MetaFieldsService {
  private title = inject(Title)
  private meta = inject(Meta)
  private translateService = inject(TranslateService)
  private destroyRef = inject(DestroyRef)

  updateTitle(titleKeys: string[]) {
    const keys = titleKeys.filter((key) => key)

    if (keys.length === 0) {
      return
    }

    combineLatest(keys.map((key) => this.translateService.getStreamOnTranslationChange(key)))
      .pipe(
        map((translations) =>
          translations
            .map((translatedValue, index) =>
              translatedValue !== keys[index] ? translatedValue : (META_TITLE_FALLBACKS[keys[index]] ?? ''),
            )
            .filter((part) => part.length > 0),
        ),
        filter((resolvedParts) => resolvedParts.length > 0),
        take(1),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((translatedTitles) => {
        const metaTitle = translatedTitles.join(` ${pageTitleSeparator} `)
        this.title.setTitle(metaTitle)
        this.meta.updateTag({ name: 'title', content: metaTitle })
        this.meta.updateTag({ property: 'og:title', content: metaTitle })
      })
  }
}
